export interface Offer {
  id: string
  name: string
  subtitle: string
  badge?: string
  includes: string[]
  /**
   * Contenido adicional exclusivo de esta oferta.
   * Reemplazar por el contenido real definido para la Oferta Completa.
   */
  extras?: string[]
  oldPrice?: string
  price: string
  ctaLabel: string
  url: string
  highlight: boolean
}

const BASE_INCLUDES = [
  '6 Tomos Carpintería Plegable PRO™',
  'Proyectos, planos y medidas',
  'Calculadora Cero Desperdicio + Cotizador PRO',
  'Guía Maestra de Herrajes Plegables',
  'Checklist Anti-Errores',
  'Kit Publicá & Vendé',
  'Plantillas de Precisión',
  'Guía de Instalación Segura',
]

export const offers: Offer[] = [
  {
    id: 'completa',
    name: 'Carpintería Plegable PRO™',
    subtitle: 'Oferta Completa',
    badge: 'Más completa',
    includes: BASE_INCLUDES,
    extras: ['Contenido adicional de la Oferta Completa — a definir'],
    price: '$26.990 ARS',
    ctaLabel: 'Quiero la oferta completa por $26.990',
    url: 'https://super-combo-carpinteria-en-aluminio.impultienda.ar/checkout/carp-alum-completo',
    highlight: true,
  },
  {
    id: 'base',
    name: 'Carpintería Plegable PRO™',
    subtitle: '6 Tomos + 6 Bonos',
    includes: BASE_INCLUDES,
    oldPrice: '$49.990',
    price: '$19.990 ARS',
    ctaLabel: 'Quiero esta oferta por $19.990',
    url: 'https://super-combo-carpinteria-en-aluminio.impultienda.ar/checkout/embudo-carp-alum',
    highlight: false,
  },
]

export const TRUST_POINTS = ['100% digital', 'Acceso inmediato', 'Pago único']
